module.exports = __webpack_public_path__ + "img/alipay_logo.ec185138.svg";